import {
  clearImportEvent,
  importEventFail,
  importEventStarted,
  importEventSuccess
} from '../../../reducer/events/ImportEventReducer';
import { postImportEvents } from '../../actionType/events/ImportActionTypes';
import {
  ClearImports,
  FetchImportFailure,
  FetchImportFailurePayload,
  FetchImportRequest,
  FetchImportStarted,
  FetchImportSuccess,
  FetchImportSuccessPayload
} from '../../types/events/ImportEventSummaryTypes';

export const fetchImportRequest = (fileData: FormData): FetchImportRequest => ({
  type: postImportEvents.POST_IMPORT_EVENTS_REQUEST,
  fileData
});

/**
 * Fetch schema started saga action
 * @returns schema started action
 */
export const fetchImportStarted = (): FetchImportStarted => ({
  type: importEventStarted.type
});

/**
 * Fetch schema success saga action
 * @param payload :schema data
 * @returns success action
 */
export const fetchImportSuccess = (
  payload: FetchImportSuccessPayload
): FetchImportSuccess => ({
  type: importEventSuccess.type,
  payload
});

/**
 * Fetch Schema Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const fetchImportFailure = (
  payload: FetchImportFailurePayload
): FetchImportFailure => ({
  type: importEventFail.type,
  payload
});

/**
 * Clear Schema saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearImportEvents = (): ClearImports => ({
  type: clearImportEvent.type
});
